































import { Component, Prop, Vue } from "vue-property-decorator";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { BButton } from "bootstrap-vue";
import RessifApexBarChart from "../templates/bar-charts/RessifApexBarChart.vue";
import { CharteGraphique } from "@/api/models/options/charteGraphique/charteGraphique";
import { TypeGraphEnum } from "@/api/models/enums/typeGraph";

@Component({
  components: {
    SearchableVueSelect,
    BButton,
    RessifApexBarChart,
  },
  name: "bar-amenagement-poste-by-parties-prenantes-externes-by-secteur-chart",
})
export default class BarAmenagementPosteByPartiesPrenantesExternesBySecteurChart extends Vue {
  @Prop({ required: true }) charteGraphique!: CharteGraphique;
  @Prop({ required: true }) model!: any;
  @Prop({ required: true }) reference!: any;

  title = "Entreprise - AMT - Aménagements de poste";
  description =
    "(254) Répartition des parties prenantes externes sur l'ensemble des aménagements de poste par secteur";

  tableFields = [
    { key: "libelle", label: "Libelle", type: "text", editable: true },
    { key: "data", label: "Data", type: "number", editable: true },
    { key: "actions", label: "Actions", editable: false },
  ];

  sampleDatas = [
  {
    id: 1,
    libelle: "Parties Prenantes Externes 1",
    data: [10, 20],
  },
  {
    id: 2,
    libelle: "PartiesPrenantesExternes 2",
    data: [30, 40]
  }
]

  addLinePayload = {
      libelle: "Autres",
      data: [],
  };

  seriesArr: any[] | null = null;
  categoriesArr: any[] | null = null;

  typeGraph = TypeGraphEnum.Individuel;
  modelCopy: any | null = null;

  created() {
    this.modelCopy = JSON.parse(JSON.stringify(this.model));
  }

  onRowDeleted(payload: any) {
    this.sampleDatas = this.sampleDatas.filter(x => x.id !== payload.id)
    // Nécessaire car editable-table demande un délai pour l'update
    setTimeout(() => {
      let dataArray = this.sampleDatas.map((x: any) => x.data)
      let seriesArray = this.sampleDatas.map((x: any) => x.libelle)

      this.seriesArr = [
        {
          key: "Data",
          name: "Data",
          data: dataArray
        },
      ];

      this.categoriesArr = seriesArray as any[]
      (this.$refs[payload.graphRef] as any).$refs[payload.graphRef].updateOptions(
        {
          xaxis: {
            categories: this.categoriesArr
          }
        }, false, true, true
      )
    }, 200);
  }

  onRowAdded(payload: any) {

    this.sampleDatas = payload.values

    // Nécessaire car editable-table demande un délai pour l'update
    setTimeout(() => {

      let dataArray = this.sampleDatas.map((x: any) => x.data)
      let seriesArray = this.sampleDatas.map((x: any) => x.libelle)

      this.seriesArr = [
        {
          key: "Data",
          name: "Data",
          data: dataArray
        },
      ];
      
      this.categoriesArr = seriesArray as any[];

      (this.$refs[payload.graphRef] as any).$refs[payload.graphRef]?.updateOptions(
        {
          xaxis: {
            categories: this.categoriesArr
          }
        }, false, true, true
      )
    }, 200);
  }

  async loadAmenagementPosteByPartiesPrenantesExternesBySecteur(graphRef: any) {
    await this.$http.ressifnet.rapportActivites
      .repartitionAmenagementPosteByPartiesPrenantesExternesBySecteur(this.model)
      .then((response: any) => {
        let seriesArray = response.secteurList.map((secteur: any) => secteur.secteurLibelle);
        let dataArray = response.partiesPrenantesExternesBySecteurList;

        this.seriesArr = [];

        dataArray.forEach((x: any) => {
          var newSerie = {
              key: x.libelle,
              name: x.libelle,
              data: x.data
          }
          this.seriesArr?.push(newSerie);
        });


        this.categoriesArr = seriesArray as any[]
        this.sampleDatas = dataArray as any[];

        (this.$refs[graphRef] as any).$refs[graphRef]?.updateOptions(
          {
            xaxis: {
              categories: this.categoriesArr
            }
          }, false, true, true
        );
        (this.$refs[graphRef] as any).loading = false;
        (this.$refs[graphRef] as any).locked = false;
      }).catch((e: any) => {
        (this.$refs[graphRef] as any).loading = false;
        (this.$refs[graphRef] as any).locked = true;
        (this.$refs[graphRef] as any).disabledButtonTrueData= false;

        let message = e.response?.data?.errors ? 
          `Un problème est survenu lors du chargement du graphique: ${Object.values(e.response.data.errors)[0]}` :
          "Un problème est survenu lors du chargement du graphique";

        this.$swal({
          title: 'Erreur',
          text: message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        })
      })
  }

  async loadTrueData(graphRef: any) {
    await this.loadAmenagementPosteByPartiesPrenantesExternesBySecteur(graphRef);
  }

  toggleExportToList(graphRef: any) {
    this.$emit("toggle-export-to-list", graphRef);
  }
  
  baseConfig = {
    series: [
      {
        key: "Premier",
        name: "Premier",
        data: [10, 20],
      },
      {
        key: "Deuxieme",
        name: "Deuxieme",
        data: [30, 40],
      },

    ],
    chartOptions: {
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: any) {
          return val
        },
        style: {
          fontSize: '15px'
        }
      },
      legend: {
        show: true,
        position: 'bottom',
        fontSize: '18px',
        width: 550,
        offsetX: 50,
      },
      stroke: {
        show: true,
        colors: ['transparent'],
      },
      grid: {
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      xaxis: {
        categories: [
          'Parties Prenantes Externes 1', 
          'Parties Prenantes Externes 2',
        ],
        labels: {
          style: {
            fontSize: '18px'
          }
        }
      },
      yaxis: {
        labels: {
          show: true,
          trim: false,
          style : {
            fontSize: '18px'
          }
        }
        // opposite: isRtl,
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
    }
  }
}
